import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-main-interface',
  templateUrl: './user-main-interface.component.html',
  styleUrls: ['./user-main-interface.component.scss']
})
export class UserMainInterfaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
